/**
 * @author: lv.chen
 * @date: 2025/8/13
 * @desc: ReportContent组件
 */
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import useCOS, { getUseAccelerateByENV } from '@gp/hooks/useCos/useCOS';
import { fetchReportGZTencentQCouldMassage } from '../../services';
import { getIsHTMLReportPath, getIsZipReportPath, buildHTMLReportPreviewUrl } from '@home/utils/reportPreview';

import './index.scss';

interface IReportContentProps extends IBaseProps {
  reportFileKey: string;
}

const ReportContent: React.FC<IReportContentProps> = (props) => {
  const { style, className, reportFileKey } = props;

  const { isCOSInited, getDocumentPreviewUrl, getObjectUrl } = useCOS({
    useAccelerate: getUseAccelerateByENV(),
    baseCOSConfigFetcher: fetchReportGZTencentQCouldMassage,
    authorizationFetcher: fetchReportGZTencentQCouldMassage,
  });

  const [previewUrl, setPreviewUrl] = useState('');

  const updatePreviewUrl = async () => {
    try {
      if (getIsZipReportPath(reportFileKey)) {
        setPreviewUrl('');
        return;
      }
      if (getIsHTMLReportPath(reportFileKey)) {
        const url = await buildHTMLReportPreviewUrl({ reportFileKey, getObjectUrl });
        setPreviewUrl(url);
        return;
      }
      const { url } = await getDocumentPreviewUrl(
        { key: reportFileKey },
        // {
        //   htmlhorizontal: '200',
        //   htmlvertical: '300',
        //   htmlfillstyle: 'rgba(106, 109, 126, 0.4)',
        //   // htmlwaterword: userName ? `${userName}@databrain` : '',
        //   htmlwaterword: '',
        // },
      );

      setPreviewUrl(url);
    } catch (error) {
      console.error(error);
      setPreviewUrl('');
    }
  };

  useEffect(() => {
    if (isCOSInited && !!reportFileKey) {
      updatePreviewUrl();
    }
  }, [isCOSInited, reportFileKey]);

  return (
    <div style={style} className={classnames('dbu-report-content', className)}>
      <div className="dbu-report-content__iframe-wrapper">
        {!!previewUrl && <iframe className="dbu-report-content__iframe" src={previewUrl} />}
      </div>
    </div>
  );
};

export default ReportContent;
